import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshTeacherPortalUser } from "../redux/userRelated/userHandle";
import { showsTeachingPortal } from "../utils/staffRoles";

/** Keep portal subject list in sync when admin assigns or removes subjects. */
export function useRefreshTeacherAssignments() {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const teacherId = currentUser?._id || currentUser?.id;
    const shouldRefresh = currentUser?.role === "Teacher" && showsTeachingPortal(currentUser);

    useEffect(() => {
        if (!shouldRefresh || !teacherId) return;
        dispatch(refreshTeacherPortalUser(teacherId));

        const onFocus = () => {
            dispatch(refreshTeacherPortalUser(teacherId));
        };
        window.addEventListener("focus", onFocus);
        return () => window.removeEventListener("focus", onFocus);
    }, [dispatch, shouldRefresh, teacherId]);
}
